import './parkrestaurant/style';
import FormStructure from './parkrestaurant/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js